module.exports = __webpack_public_path__ + "img/COVID_Public_Desktop_Banner.0e274383.jpg";